type CookieObj = {
  [x: string]: string;
};

export const parseCookie = (cookieString: string) => {
  return cookieString
    .split(';')
    .map(item => item.split('='))
    .reduce((acc, [k, v]) => {
      acc[k.trim().replace('"', '')] = v;
      return acc;
    }, {} as CookieObj);
};

export function getCookie(name: string) {
  let matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? matches[1] : undefined;
}
